"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (lowerBound, upperBound) {
  return function (value) {
    return value <= upperBound && value >= lowerBound;
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/state/is-within.js
// module id = 479
// module chunks = 0